import { Route, Routes } from 'react-router-dom';
import { PlatformItemList } from './components/PlatformItemList';
import { PlatformForm } from './components/PlatformForm';
import { PlatformItemForm } from './components/PlatformItemForm';
import { PlatformList } from './components/PlatformList';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import { hasAccessRight } from '../../utils/Functions';

export function PlatformRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.PLATFORM) && (
                <>
                    <Route path="item" element={<PlatformItemList />} />
                    <Route path="item/form/:platformItemId?" element={<PlatformItemForm />} />
                    <Route path="platforms" element={<PlatformList />} />
                    <Route path="form/:platformId?" element={<PlatformForm />} />
                </>
            )}
        </Routes>
    );
}
